import type { HeavenlyStem } from '../types/stems';
import type { FourPillars } from '../types/pillars';
import type { DailyFortune } from '../types/fortune';
import type { YongSin } from '../types/strength';
import type { GyeokGukAnalysis } from '../types/gyeok-guk';
import { getDayPillarRaw } from '../pillars/day-pillar';
import { getTenGod } from '../analysis/ten-gods';
import { addDays } from '../calendar/date-utils';
import { analyzeFortuneRelations } from '../relations/fortune-relations';

/**
 * 특정 날짜의 일운을 계산한다.
 *
 * 해당 날짜의 일주(육십갑자)를 사용한다.
 */
export function getDailyFortune(
  dayMaster: HeavenlyStem,
  year: number, month: number, day: number,
  fourPillars?: FourPillars, noHour?: boolean,
  yongSin?: YongSin, gyeokGuk?: GyeokGukAnalysis,
): DailyFortune {
  const pillar = getDayPillarRaw(year, month, day);
  return {
    year, month, day, pillar,
    tenGod: getTenGod(dayMaster, pillar.stem),
    relations: fourPillars ? analyzeFortuneRelations(fourPillars, pillar, noHour, yongSin, gyeokGuk) : [],
  };
}

export function getDailyFortuneRange(
  dayMaster: HeavenlyStem,
  year: number, month: number, day: number, count: number,
  fourPillars?: FourPillars, noHour?: boolean,
  yongSin?: YongSin, gyeokGuk?: GyeokGukAnalysis,
): DailyFortune[] {
  const result: DailyFortune[] = [];
  let current = { year, month, day };

  for (let i = 0; i < count; i++) {
    result.push(getDailyFortune(dayMaster, current.year, current.month, current.day, fourPillars, noHour, yongSin, gyeokGuk));
    current = addDays(current.year, current.month, current.day, 1);
  }

  return result;
}
